<template>
  <div class="zoho">
    <div class="widget">
      <div class="widget-body">
        <div class="d-flex justify-content-between align-items-center">
          <div class="state">
            <h4>
              Zoho CRM
              <small v-if="!activeIntegration">(Inativo)</small>
            </h4>
          </div>
          <div class="icon">
            <div class="d-flex align-items-center">
              <artificial-intelligence-icon add-margin-right="20px" />
              <div v-if="activeIntegration">
                <font
                  title="Configurações"
                  size="6"
                  color="black"
                  @click.prevent="toogleUpdateIntegration()">
                  <i class="ik ik-settings" />
                </font>
              </div>
              <div v-else>
                <font
                  title="Configurações"
                  size="6"
                  color="gray">
                  <i class="ik ik-settings" />
                </font>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <small class="text-small mt-10 d-block">
            <toggle-button
              tag="zoho"
              class="mb-1"
              :width="90"
              :height="30"
              :font-size="15"
              :value="activeIntegration"
              :sync="true"
              :labels="{checked: 'Ativo', unchecked: 'Ativar'}"
              @change="toogleIntegration" />
          </small>
          <font
            title="Tutorial"
            size="6"
            color="black"
            @click.prevent="openTutorial">
            <i class="ik ik-youtube" />
          </font>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="confirmDelete"
      ref="confirmDelete"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <h4 class="modal-title">Você tem certeza que deseja remover a integração com o Zoho CRM?</h4>
          </div>
          <div class="modal-footer">
            <div class="buttons">
              <button
                type="button"
                class="btn btn-outline-secondary"
                data-dismiss="modal">Não</button>
              <button
                type="button"
                class="btn btn-primary"
                @click.prevent="deleteIntegration">Sim</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="updateIntegration"
      ref="updateIntegration"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Configurar Zoho CRM</h4>
            <div class="d-flex align-items-center">
              <artificial-intelligence-icon />
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>
          <div class="modal-body">
            <ErrorAlert :error="errorAlert" />
            <div class="form-group row">
              <label class="col-sm-4 col-form-label">Usuário Zoho CRM</label>
              <div class="col-sm-8">
                <select
                  class="form-control"
                  id="userId"
                  v-model="userId">
                  <option
                    v-for="option in usersOptions"
                    :key="option.value"
                    :value="option.value">
                    {{ option.text }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-4 col-form-label">Chamada Atendida</label>
              <div class="col-sm-8">
                <select
                  class="form-control"
                  id="callResultValueAnswered"
                  v-model="callResultValueAnswered">
                  <option
                    v-for="option in callResultsOptions"
                    :key="option.value"
                    :value="option.value">
                    {{ option.text }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-4 col-form-label">Chamada Não Atendida</label>
              <div class="col-sm-8">
                <select
                  class="form-control"
                  id="callResultValueNotAnswered"
                  v-model="callResultValueNotAnswered">
                  <option
                    v-for="option in callResultsOptions"
                    :key="option.value"
                    :value="option.value">
                    {{ option.text }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="buttons">
              <button
                type="button"
                class="btn btn-primary"
                :disabled="!configReady"
                @click.prevent="saveIntegration">Salvar</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="successIntegration"
      ref="successIntegration"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-sm modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <h5 class="modal-title">Integração Zoho CRM atualizada com sucesso!</h5>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              data-dismiss="modal">OK</button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="uninstallIntegration"
      ref="uninstallIntegration"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-sm modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <h5 class="modal-title">Integração Zoho CRM removida com sucesso!</h5>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              data-dismiss="modal">OK</button>
          </div>
        </div>
      </div>
    </div>
    <tutorial-video-modal
      ref="tutorialZohoCrm"
      title="Tutorial Zoho CRM"
      video-url="https://www.youtube.com/embed/3IB-nH8qUco?si=AgEie7YHSHOJKp5B" />
  </div>
</template>

<script>
import loopback from '@/services/loopback'
import ArtificialIntelligenceIcon from '@/components/Common/ArtificialIntelligenceIcon.vue'
import TutorialVideoModal from '@/components/Common/TutorialVideoModal.vue'

export default {
  name: 'IntegrationZoho',
  components: {
    ArtificialIntelligenceIcon,
    TutorialVideoModal
  },
  data () {
    return {
      error: null,
      integration: null,
      configReady: false,
      userId: null,
      usersOptions: [],
      callResultValueAnswered: null,
      callResultValueNotAnswered: null,
      callResultsOptions: []
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.loadIntegration()
    })
  },
  methods: {
    loadIntegration () {
      return new Promise(resolve => {
        return loopback
          .get(`/integrations?filter[where][gateway]=zoho`)
          .then(integrations => {
            this.integration = integrations.pop()
            if (this.integration && this.integration.metadata) {
              if (this.integration.metadata.userId) this.userId = this.integration.metadata.userId
              if (this.integration.metadata.callResultValueAnswered) this.callResultValueAnswered = this.integration.metadata.callResultValueAnswered
              if (this.integration.metadata.callResultValueNotAnswered) this.callResultValueNotAnswered = this.integration.metadata.callResultValueNotAnswered
            }
            return resolve()
          })
          .catch(err => { this.$emit('onError', err) })
      })
    },
    saveIntegration () {
      return new Promise(resolve => {
        this.error = null
        if (!this.configReady) {
          this.error = 'Houve um erro ao salvar a integração. Por favor, tente novamente.'
          return resolve()
        }
        const integrationParams = {
          gateway: 'zoho',
          webhook: true,
          webhookConstraint: {
            metadata: {
              api4comGateway: 'zoho'
            }
          },
          metadata: {
            webhookUrl: `${process.env.API4COM_BASE_URL_API}${process.env.API4COM_VERSION_API}/integrations/webhook`,
            webhookVersion: 'v1.4',
            webhookTypes: ['channel-hangup']
          }
        }
        if (this.integration) integrationParams.id = this.integration.id
        if (this.integration && this.integration.metadata) integrationParams.metadata = Object.assign(this.integration.metadata, integrationParams.metadata)

        if (this.userId) integrationParams.metadata.userId = this.userId
        else delete integrationParams.metadata.userId

        if (this.callResultValueAnswered) integrationParams.metadata.callResultValueAnswered = this.callResultValueAnswered
        else delete integrationParams.metadata.callResultValueAnswered

        if (this.callResultValueNotAnswered) integrationParams.metadata.callResultValueNotAnswered = this.callResultValueNotAnswered
        else delete integrationParams.metadata.callResultValueNotAnswered

        loopback
          .patch('/integrations', integrationParams)
          .then(integration => {
            this.integration = integration
            $(this.$refs.updateIntegration).modal('hide')
            $(this.$refs.successIntegration).modal('show')
            return resolve()
          })
          .catch(err => {
            this.error = err
          })
      })
    },
    toogleIntegration (event) {
      if (event.value === true) {
        return this.requestAuthorization()
      } else {
        $(this.$refs.confirmDelete).modal('show')
      }
    },
    toogleUpdateIntegration () {
      this.error = null
      this.configReady = false
      this.loadUsers().then(_ => {
        this.loadCallResults().then(_ => {
          this.configReady = true
        })
      })
      $(this.$refs.updateIntegration).modal('show')
    },
    deleteIntegration () {
      if (!this.integration) return
      loopback
        .delete(`/integrations/${this.integration.id}`)
        .then(_ => {
          this.integration = null
          this.configReady = false
          $(this.$refs.uninstallIntegration).modal('show')
          this.usersOptions = []
          this.userId = ''
        })
        .finally(_ => {
          $(this.$refs.confirmDelete).modal('hide')
        })
        .catch(err => { this.$emit('onError', err) })
    },
    requestAuthorization () {
      return loopback
        .get(`/integrations/zoho/authorize-link`)
        .then(link => {
          window.open(link, '_self')
        })
        .catch(err => { this.$emit('onError', err) })
    },
    loadUsers () {
      return new Promise(resolve => {
        return loopback
          .get(`/integrations/zoho/users`)
          .then(users => {
            if (users && users.length > 0) {
              this.usersOptions = []
              if (!this.userId) this.userId = users[0].id
              users.forEach(user => {
                this.usersOptions.push({
                  value: user.id,
                  text: `${user.first_name} ${user.last_name ? user.last_name : ''} (${user.email})`
                })
              })
              return resolve()
            } else {
              return resolve()
            }
          })
          .catch(err => this.errorHandle(err))
      })
    },
    loadCallResults () {
      return new Promise(resolve => {
        return loopback
          .get(`/integrations/zoho/call-results`)
          .then(callResults => {
            if (callResults && callResults.length > 0) {
              this.callResultsOptions = []
              if (!this.callResultValueAnswered) this.callResultValueAnswered = callResults[0].display_value
              if (!this.callResultValueNotAnswered) this.callResultValueNotAnswered = callResults[0].display_value
              callResults.filter(d => d.actual_value !== '-None-').forEach(callResult => {
                this.callResultsOptions.push({
                  value: callResult.display_value,
                  text: callResult.display_value
                })
              })
              return resolve()
            } else {
              return resolve()
            }
          })
          .catch(err => this.errorHandle(err))
      })
    },
    errorHandle (err) {
      console.error(err)
      this.error = {
        message: 'Houve um problema com a autenticação da integração. Talvez seja necessário reinstalar essa integração.'
      }
    },
    openTutorial () {
      this.$refs.tutorialZohoCrm.open()
    }
  },
  computed: {
    // TEL-2243: esta tela guarda `error` como string escrita por ela mesma. O
    // ErrorAlert so aceita objeto — sem este envelope a validacao de prop reprova
    // e a tela nao renderiza erro nenhum. Mesmo padrao das telas de CRM irmas.
    errorAlert () {
      if (!this.error) return null
      return typeof this.error === 'string' ? { lines: [this.error] } : this.error
    },
    activeIntegration () {
      return this.integration && this.integration.gateway === 'zoho'
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Integration/ZohoCrm.vue